(() => {
  const form = document.getElementById('SaariyRepairRequest');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const success = form.querySelector('[data-repair-success]');
  if (success) { success.focus(); return; }
  const params = new URLSearchParams(location.search);
  const model = form.querySelector('[data-repair-model]');
  const service = form.querySelector('[data-repair-service]');
  const normalize = value => value.replace('آيفون', 'iPhone').replace('برو ماكس', 'Pro Max').replace('برو', 'Pro').trim();
  const requestedModel = normalize(params.get('model') || '');
  if (Array.from(model.options).some(option => option.value === requestedModel)) model.value = requestedModel;
  const requestedService = params.get('service');
  if (Array.from(service.options).some(option => option.value === requestedService)) service.value = requestedService;
  const where = form.querySelector('[data-repair-location]');
  const requestedLocation = params.get('location');
  if (Array.from(where.options).some(option => option.value === requestedLocation)) where.value = requestedLocation;
  const note = form.querySelector('[data-home-note]');
  const update = () => { note.hidden = where.value !== 'At home'; };
  where.addEventListener('change', update); update();
  const date = form.querySelector('[data-repair-date]');
  const now = new Date();
  date.min = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
})();


